function initFreshChat() {
    window.fcWidget.init({
            token: "66689fda-78ba-4cf2-92b2-b3b321e9c957",
            host: "https://bensonsforbeds-team.freshchat.com",
            widgetUuid: "d0e4b950-f0ee-4acf-93d3-fc94b8afed52"
    });
  }
  function initialize(i,t){var e;i.getElementById(t)?
  initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,
  e.src="https://bensonsforbeds-team.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}
  function initiateCall(){initialize(document,"Freshchat-js-sdk")}
  window.addEventListener?window.addEventListener("load",initiateCall,!1):
  window.attachEvent("load",initiateCall,!1);